/*
 * @Author: your name
 * @Date: 2021-02-21 22:03:08
 * @LastEditTime: 2022-03-01 22:44:45
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /red_packet_admin/src/api/modules/user.js
 */
import request from "../request";

// 登陆用户列表
export function uploadImage(data) {
  return request({
    url: "/image/upload",
    method: "post",
    data,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

// 删除图片
export function deleteImage(data) {
  return request({
    url: "/image/delete",
    method: "post",
    data,
  });
}

// 省市区
export function getCities(params) {
  return request({
    url: "/common/getCities",
    method: "get",
    params,
  });
}

// 获取医院列表数据

export function getHospitals(keyword) {
  return request({
    url: "/common/getHospitals",
    method: "get",
    params: { keyword },
  });
}
